angular.module('leanlaw').controller('MatterLedesCtrl', ['$scope', '$rootScope', '$timeout', 'alerts', 'clientMatterManager', 'lists', 'codeService', 'userService', '$state', function ($scope, $rootScope, $timeout, alerts, clientMatterManager, lists, codeService, userService, $state) {
  $scope.lists = lists;
  $scope.codes = {};
  activate();
  $scope.save = function () {
    $scope.saving = true;
    $scope.codes.format = $scope.format.id;

    // Build split billing configuration
    const ledesSplitAdjustment = $scope.splitBillingMethod && $scope.splitBillingMethod.value ? {
      method: $scope.splitBillingMethod.value,
      description: $scope.splitBillingDescription || ''
    } : null;
    clientMatterManager.getClient($scope.matter.client.id).then(client => {
      client.update({
        settings: {
          codes: $scope.codes
        }
      }).then(() => $scope.matter.update({
        // Update top-level matter fields
        externalId: $scope.matter.externalId,
        ledesId: $scope.matter.ledesId,
        ledesInvoiceDescription: $scope.matter.ledesInvoiceDescription,
        // Update nested settings
        settings: {
          codes: {
            ...$scope.matter.settings?.codes,
            ledesSplitAdjustment: ledesSplitAdjustment
          }
        }
      }).then(matter => {
        $scope.saving = false;
        $scope.billingForm.$setPristine();
        return $scope.assignMatterToScope(matter);
      })).catch(err => {
        $scope.saving = false;
        alerts.error(err);
      });
    });
  };
  $scope.cancel = function () {
    $scope.error = false;
    $scope.matter.reload().then(matter => {
      $scope.billingForm.$setPristine();
      $scope.assignMatterToScope(matter);
    });
  };
  const deactivate = $rootScope.$on('$stateChangeStart', (event, transition) => {
    if ($scope.billingForm && $scope.billingForm.$dirty) {
      $scope.unsaved = true;
      $timeout(() => {
        $scope.unsaved = false;
      }, 4000);
      event.preventDefault();
    } else {
      deactivate();
    }
  });

  ///////////////////////////////////

  async function activate() {
    const me = await userService.me();
    if (me.features.ledesXml2) {
      $state.go('matters-next.client.matter.ledes2', {
        id: $scope.matter.client.id,
        matterId: $scope.matter.id
      });
      return;
    }
    $scope.formats = [{
      id: 'ledes98',
      label: 'LEDES 1998b'
    }, {
      id: 'ledes2000',
      label: 'LEDES 2000'
    }, {
      id: 'ledesLss',
      label: 'LEDES LSS'
    }];
    if (me.features.ledesXml2) {
      $scope.formats.push({
        id: 'ledesXml2',
        label: 'LEDES XML 2.0'
      });
    }

    // Split billing method options
    $scope.splitBillingMethodOptions = [{
      label: 'Full Invoice (No Adjustment)',
      value: 'fullInvoice'
    }, {
      label: 'Invoice-Level Adjustment',
      value: 'invoiceLevelAdjustment'
    }];
    codeService.activityCodes().then(activity => {
      $scope.codes.activity = activity;
    });
    codeService.taskCodes().then(task => {
      $scope.codes.task = task;
    });
    $scope.$watch('matter', matter => {
      $scope.codes = {};
      if (matter.billing && matter.client.codes) {
        $scope.codes = angular.copy(matter.client.codes);
      }
      $scope.format = $scope.codes.format ? {
        id: $scope.codes.format
      } : $scope.formats[0];

      // Handle split billing configuration
      if (matter.settings && matter.settings.codes && matter.settings.codes.ledesSplitAdjustment) {
        const splitAdjustment = matter.settings.codes.ledesSplitAdjustment;
        $scope.splitBillingMethod = $scope.splitBillingMethodOptions.find(option => option.value === splitAdjustment.method);
        $scope.splitBillingDescription = splitAdjustment.description || '';
      } else {
        $scope.splitBillingMethod = null;
        $scope.splitBillingDescription = '';
      }
      $scope.defaultLedesId = matter.reference || matter.name;
      if ($scope.defaultLedesId && $scope.defaultLedesId.length > 25) {
        $scope.defaultLedesId = $scope.defaultLedesId.substring(0, 25);
      }
    });
    $scope.$watch('billingForm.$dirty', dirty => {
      $scope.$emit('matterBillingIsDirty', dirty);
    }, true);
  }
}]);